
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import LegalContent from './LegalContent.vue';

@Component({
    components: {
        LegalContent,
    }
})
export default class Legal extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    public value!: boolean;    
    public dialogOpen!: boolean;
}
